<se-fe-page [seFeDataLoaded]="itemLoaded" [seFeDataBackLink]="'../../../detail'" [seFeDataBackText]="$safeNavigationMigration(item?.name)">
  <se-fe-header
    seFePageHeader
    [seFeDataTitle]="'VARIATION_DETAIL_VIEW.title' | translate"
  seFeDataSize="750"></se-fe-header>

  <div seFePageContent>
    @if (item && variation) {
      <se-fe-grid seFeGridOpts>
        <se-fe-grid-cell seFeGridOpts="1/1">
          <se-fe-card class="item-variation-detail__details-card">
            <se-fe-card-header
              class="item-variation-detail__card-header"
            [seFeDataTitle]="variation.name"></se-fe-card-header>
            <se-fe-card-content>
              <se-fe-grid seFeGridOpts="loose">
                <se-fe-grid-cell seFeGridOpts="1/3@desktop 1/3@tablet 1/1@mobile">
                  <span
                    class="item-variation-detail__field-label"
                  [translate]="'VARIATION_DETAIL_VIEW.sale_item'"></span>
                  <div class="item-variation-detail__field-value">
                    <a seFeLink [routerLink]="['../../../detail']">{{ item.name }}</a>
                  </div>
                </se-fe-grid-cell>

                <se-fe-grid-cell seFeGridOpts="1/3@desktop 1/3@tablet 1/1@mobile">
                  <span class="item-variation-detail__field-label" [translate]="'VARIATION_DETAIL_VIEW.price'"></span>
                  <div class="item-variation-detail__field-value">
                    {{ variation.price | currency: variation.currency }}
                  </div>
                  @if (showUpfrontAmountText) {
                    <div
                      class="item-variation-detail__price-note pl-help-text--below line-break"
                    [innerHTML]="upfrontAmountSettingText"></div>
                  }
                </se-fe-grid-cell>

                <se-fe-grid-cell seFeGridOpts="1/3@desktop 1/3@tablet 1/1@mobile">
                  <span class="item-variation-detail__field-label" [translate]="'VARIATION_DETAIL_VIEW.sku'"></span>
                  <div class="item-variation-detail__field-value">{{ variation.sku || '--' }}</div>
                </se-fe-grid-cell>
              </se-fe-grid>
            </se-fe-card-content>
          </se-fe-card>
        </se-fe-grid-cell>

        <se-fe-grid-cell seFeGridOpts="1/1">
          <se-fe-card class="item-variation-detail__sales-card">
            <se-fe-card-header
              class="item-variation-detail__card-header"
              [seFeDataTitle]="'VARIATION_DETAIL_VIEW.sales' | translate">
              <div seFeCardHeaderActions>{{ salesSummary }}</div>
            </se-fe-card-header>

            <se-fe-card-content>
              @if (!saleItemLoaded || showOverlay) {
                <se-fe-spinner
                  class="item-variation-detail__loading"
                  [seFeDataSize]="900"
                [seFeDataCenter]="true"></se-fe-spinner>
              }

              @if (saleItemLoaded && !showOverlay && !saleItems.length) {
                <se-fe-empty-state
                  [seFeDataTitle]="'VARIATION_DETAIL_VIEW.nothing_to_report' | translate"
                  seFeDataSize="500">
                  {{ 'VARIATION_DETAIL_VIEW.not_sold' | translate }}
                </se-fe-empty-state>
              }

              @if (saleItemLoaded && !showOverlay && saleItems.length) {
                <se-fe-table-wrapper>
                  <table seFeTable [dataSource]="saleItems" [seFeDataFixedLayout]="false">
                    <ng-container seFeColumnDef="created_at">
                      <th seFeHeaderCell *seFeHeaderCellDef>
                        {{ 'VARIATION_DETAIL_VIEW.date' | translate }}
                      </th>
                      <td seFeCell *seFeCellDef="let saleItem">{{ saleItem.sale.created_at | date }}</td>
                    </ng-container>
                    <ng-container seFeColumnDef="type">
                      <th seFeHeaderCell *seFeHeaderCellDef>
                        {{ 'VARIATION_DETAIL_VIEW.type' | translate }}
                      </th>
                      <td seFeCell *seFeCellDef="let saleItem">{{ saleItem.sale.type }}</td>
                    </ng-container>
                    <ng-container seFeColumnDef="sale">
                      <th seFeHeaderCell *seFeHeaderCellDef>
                        {{ 'VARIATION_DETAIL_VIEW.sale' | translate }}
                      </th>
                      <td seFeCell *seFeCellDef="let saleItem">
                        @if (saleItem.sale.sale_number) {
                          <a seFeLink [href]="getSaleUrl(saleItem.sale)" target="_top">
                            {{ saleItem.sale.sale_number }}
                          </a>
                        }
                      </td>
                    </ng-container>
                    <ng-container seFeColumnDef="member">
                      <th seFeHeaderCell *seFeHeaderCellDef>
                        {{ 'VARIATION_DETAIL_VIEW.member' | translate }}
                      </th>
                      <td seFeCell *seFeCellDef="let saleItem">
                        @if (saleItem.sale.persona_id) {
                          <a
                            seFeLink
                            [href]="getMemberUrl(saleItem.sale.persona_id)"
                            target="_top">
                            {{ saleItem.sale.user_full_name }}
                          </a>
                        }
                        @if (!saleItem.sale.persona_id && saleItem.sale.user_full_name) {
                          <span>
                            {{ saleItem.sale.user_full_name }}
                          </span>
                        }
                        @if (!saleItem.sale.user_full_name) {
                          <span
                          [translate]="'VARIATION_DETAIL_VIEW.anonymous_user'"></span>
                        }
                      </td>
                    </ng-container>
                    <ng-container seFeColumnDef="price">
                      <th seFeHeaderCell class="item-variation-detail__cell--right" *seFeHeaderCellDef>
                        {{ 'VARIATION_DETAIL_VIEW.price' | translate }}
                      </th>
                      <td seFeCell class="item-variation-detail__cell--right" *seFeCellDef="let saleItem">
                        {{ saleItem.price | currency: saleItem.currency }}
                      </td>
                    </ng-container>
                    <ng-container seFeColumnDef="quantity">
                      <th seFeHeaderCell *seFeHeaderCellDef>
                        {{ 'VARIATION_DETAIL_VIEW.quantity' | translate }}
                      </th>
                      <td seFeCell *seFeCellDef="let saleItem">{{ saleItem.quantity }}</td>
                    </ng-container>
                    <ng-container seFeColumnDef="item_total">
                      <th seFeHeaderCell class="item-variation-detail__cell--right" *seFeHeaderCellDef>
                        {{ 'VARIATION_DETAIL_VIEW.item_total' | translate }}
                      </th>
                      <td seFeCell class="item-variation-detail__cell--right" *seFeCellDef="let saleItem">
                        {{ saleItem.amount | currency: saleItem.currency }}
                      </td>
                    </ng-container>
                    <tr seFeHeaderRow *seFeHeaderRowDef="saleColumns; sticky: false"></tr>
                    <tr seFeRow *seFeRowDef="let row; columns: saleColumns"></tr>
                  </table>
                </se-fe-table-wrapper>
                <se-fe-pagination
                  [seFeDataPaginationOptions]="salesPaginationOptions"
                (seFePaginationChange)="handleSalesPagination($event)"></se-fe-pagination>
              }
            </se-fe-card-content>
          </se-fe-card>
        </se-fe-grid-cell>
      </se-fe-grid>
    }
  </div>
</se-fe-page>
